import React from 'react'
import Image404 from "../img/404 Error.gif"

const Page404 = () => {
    return (
        <div className='w-full h-screen flex items-center justify-center '>
            <img src={Image404} alt="imagen 404 " />
        </div>
    )
}

export default Page404